/**
 * Kanonisk sökväg per offertkategori, t.ex. hembatterier → /batterier.
 *
 * Ligger i en egen liten modul så att rutter (t.ex. /jamfor-offerter/$slug)
 * kan använda den utan att importera hela OffertKategori-sidan – en sådan
 * import drog in sidan, kalkylatorerna och produktkatalogen i huvudpaketet.
 */
export const categoryPaths: Record<string, string> = {
  solceller: "/solceller",
  hembatterier: "/batterier",
  varmepumpar: "/varmepumpar",
  laddboxar: "/laddboxar",
  laddstolpar: "/laddstolpar",
  "kommersiella-solceller": "/kommersiella-solceller",
  "kommersiella-batterier": "/kommersiella-batterier",
};

export const isOfferCategory = (slug: string) => Object.prototype.hasOwnProperty.call(categoryPaths, slug);

export const categoryPath = (slug: string) => categoryPaths[slug] ?? `/${slug}`;
